export default __webpack_public_path__ + "static/media/BillImage.ea33961c.png";